import { Response } from '@angular/http';


export interface IBaseResponse<T> {
    IsHttpError(): boolean;
    StatusCode(): number;
    StatusCodeText(): string;
    InitFromJSON();


    Result: boolean;
    Message: string;
    Redirect: string;
    Data: T;

    HttpResponse: Response;
}

export class BaseResponse<T> implements IBaseResponse<T>  {

    public Result: boolean;
    public Message: string;
    public Redirect: string;
    public Data: T;
    public DateItemsCount: number = 0;
    public HttpResponse: Response;


    public InitFromJSON() {
        Object.setPrototypeOf(this, BaseResponse.prototype);
    }


    public IsHttpError(): boolean {
        if (!this.HttpResponse)
            return false;

        return (this.HttpResponse.status !== 200);
    }

    public StatusCode(): number {
        if (!this.HttpResponse)
            return 0;

        return this.HttpResponse.status;
    }

    public StatusCodeText(): string {
        if (!this.HttpResponse)
            return '';

        return this.HttpResponse.statusText;
    }

}
